import { useNavigate } from "react-router-dom"
import { Header } from "../IndexPage/Header/Header"

export const About = () => {
    const navigate = useNavigate()

    const check = [
        {
            id: 0, Name: 'Namita',
            ImgSrc: "Static/Assets/Img/light-bulb.gif",
            Count: 22,
            bgcolor: '#ececec',
            border: '1px solid red',

        },
        {
            id: 1, Name: 'Dilip',
            ImgSrc: "Static/Assets/Img/agreement.gif",
            Count: 150,
            bgcolor: 'pink',
            border: '1px solid red',
        },
        {
            id: 2, Name: 'Pawar',
            ImgSrc: "Static/Assets/Img/logo.png",
            Count: 88,
            bgcolor: '#ececec',
            border: '1px solid red',
        },
    ]
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <Header />

                    <div className="row p-5 mt-5">

                        {
                            check.map((Array) => {

                                return (

                                    <div className="col-12 col-lg-4  mt-5 text-center" >
                                        <div className="p-5 " style={{ backgroundColor: (Array.bgcolor), border: (Array.border) }} >
                                            <h5>{Array.Name}  </h5>
                                            <img src={Array.ImgSrc} alt="" srcset="" style={{ width: '150px' }} onClick={() => navigate('/')} />
                                            <h1 className="fw-bold pt-4">{Array.Count}</h1>
                                        </div>
                                    </div>

                                )

                            }
                            )
                        }

                    </div>

                </div>
            </div>
        </>
    )
}